import styles from "./Header.module.css";

const header = () => {
  return <div className={styles.header}></div>;
};

export default header;
